import {
  EuiButton,
  EuiFlexGroup,
  EuiFlexItem,
  EuiFormRow,
  EuiSpacer,
  EuiTitle,
} from "@elastic/eui";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../slices/RootReducer";
import { setBusinessBuilderAction } from "../../slices/NewOrderCreateSlice";
import { useGetAddonsQuery } from "../../api/rtkQueryApi/AddonsApi";
import { AddonDetails } from "../../api/entities/Addon";
import { AddonSelector } from "../../components/addons/AddonSelector";
import { AddonsCardViewer } from "pages/addons/AddonsCardViewer";

export const NewOrderAddons: React.FC = () => {
  const { businessBuilder } = useSelector((state: RootState) => state.newOrder);
  const { businessId } = useParams();
  const navigate = useNavigate();
  const getAddonsQuery = useGetAddonsQuery();
  const [selectedAddons, setSelectedAddons] = useState<AddonDetails[]>([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (businessBuilder.addons && getAddonsQuery.data) {
      const _addons: AddonDetails[] = [];
      businessBuilder.addons.forEach((addonDetails) => {
        _addons.push(addonDetails);
      });
      setSelectedAddons(_addons);
    }
  }, [businessBuilder.addons, getAddonsQuery.data]);

  const navigateBack = () => {
    if (businessId) {
      navigate(`/business/${businessId}/new/product`);
    } else {
      navigate("/new/product");
    }
  };

  const navigateNext = () => {
    if (businessId) {
      navigate(`/business/${businessId}/new/payment`);
    } else {
      navigate("/new/payment");
    }
  };

  const onBackClick = () => {
    dispatch(
      setBusinessBuilderAction({
        ...businessBuilder,
        addons: selectedAddons,
      }),
    );

    navigateBack();
  };

  const onContinueToPaymentClick = () => {
    dispatch(
      setBusinessBuilderAction({
        ...businessBuilder,
        addons: selectedAddons,
      }),
    );

    navigateNext();
  };

  const onAddonSelected = (addon: AddonDetails) => {
    setSelectedAddons((prev) => {
      return [...prev, addon];
    });
  };

  const onAddonRemoved = (addon: AddonDetails) => {
    setSelectedAddons((tAddons) => {
      const cAddons = [...tAddons];
      const index = cAddons.findIndex((a) => a.id === addon.id);
      if (index > -1) {
        cAddons.splice(index, 1);
      }
      return [...cAddons];
    });
  };

  const onCustomizableAddonUpdated = (
    addonDetailsId: string,
    startDate?: string,
    contractLength?: number,
  ) => {
    setSelectedAddons((tAddons) => {
      const cAddons = [...tAddons];
      const addonDetails = {
        ...cAddons.find((a) => a.id === addonDetailsId),
      } as AddonDetails;

      if (addonDetails) {
        addonDetails.startDate = startDate;
        addonDetails.contractLength = contractLength;

        const index = cAddons.findIndex((a) => a.id === addonDetailsId);
        if (index > -1) {
          cAddons.splice(index, 1, addonDetails);
        }
      }

      return [...cAddons];
    });
  };

  if (!businessBuilder.productGroupId || !businessBuilder.product) {
    return <></>;
  }

  return (
    <>
      <EuiFormRow>
        <EuiFlexGroup>
          <EuiFlexItem grow={false}>
            <EuiButton onClick={onBackClick}>Back</EuiButton>
          </EuiFlexItem>
          <EuiFlexItem grow={false}>
            <EuiButton fill onClick={onContinueToPaymentClick}>
              Continue to Payment
            </EuiButton>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFormRow>
      <EuiSpacer />
      {selectedAddons.length > 0 && (
        <>
          <EuiTitle size={"s"}>
            <h2>Selected Addons</h2>
          </EuiTitle>
          <EuiSpacer />
          <AddonsCardViewer
            addons={selectedAddons}
            onAddonRemoveClick={onAddonRemoved}
            productGroupId={businessBuilder.productGroupId}
            productDetails={businessBuilder.product}
            onCustomizableAddonUpdated={onCustomizableAddonUpdated}
          />
          <EuiSpacer />
        </>
      )}
      <EuiTitle size={"s"}>
        <h2>Available Addons</h2>
      </EuiTitle>
      <EuiSpacer />
      <AddonSelector
        productGroupId={businessBuilder.productGroupId}
        onAddonSelected={onAddonSelected}
      />
    </>
  );
};
